import type {
	DeploymentFrequencyReportWithProviderInfo,
	DeploymentFrequencyReportWeekData,
} from '../../common/types.tsx';

type DateOption = {
	startDateInclusive: Date;
};

const mostRecentDateComparator = (a: DateOption, b: DateOption): number =>
	b.startDateInclusive.getTime() - a.startDateInclusive.getTime();

// only allow weeks with production deployments to be selectable
export const getDateOptionsFromCoreData = (
	coreData: DeploymentFrequencyReportWithProviderInfo,
): DateOption[] =>
	coreData.weeksData
		.filter((weekData: DeploymentFrequencyReportWeekData) => weekData.deploymentCount.prod > 0)
		.map((weekData: DeploymentFrequencyReportWeekData) => ({
			startDateInclusive: weekData.startDateInclusive,
		}))
		.sort(mostRecentDateComparator);
